import { RG_TYPE } from '../../types/rg-type.js';

/**
 * A collection of `RG_TYPE` that behave like an apartment - contains modules and other children
 */
const ApartmentLikeTypes = [RG_TYPE.Apartment, RG_TYPE.TechnicalSpace];

export { ApartmentLikeTypes };
//# sourceMappingURL=apartment-like-types.js.map
